// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2M_CE","bigColWidth":"Table_bigColWidth__3l7u6","biggerColWidth":"Table_biggerColWidth__1BDvJ","row":"Table_row__2BzPn","col":"Table_col__3l95r"};